import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/286'

const DigitalOrdersByHourTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="digital_ordering.tabs.digital_orders_by_hour"
  />
)

export default DigitalOrdersByHourTab
